import { FaCoffee, FaSmile, FaCalendarAlt, FaBeer } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCoffee />, // Coffee cup icon
        title: 'Coffee Served',
        count: '9000',
    },
    {
        id: 2,
        icon: <FaSmile />, // Smile icon
        title: 'Happy Customers',
        count: '6780',
    },
    {
        id: 3,
        icon: <FaCalendarAlt />, // Calendar icon
        title: 'Years in Business',
        count: '10',
    },
    {
        id: 4,
        icon: <FaBeer />, // Beer mug icon (used for coffee varieties)
        title: 'Coffee Varieties',
        count: '40',
    },
];

export default counter;